import { ProjectContentItemDc } from "@evergis/api";

export const checkLayersFilterCondition = (alias: string, searchFilter = ""): boolean => {
  return alias?.toLowerCase().includes(searchFilter.toLowerCase()) || false;
};

export const layersTreeFilter = (layers: ProjectContentItemDc[], searchFilter = ""): ProjectContentItemDc[] => {
  return layers.reduce((result, layer) => {
    if (layer.children)
      return [
        ...result,
        {
          ...layer,
          children: layersTreeFilter(layer.children, searchFilter),
        },
      ];

    if (checkLayersFilterCondition(layer.alias || layer.name, searchFilter)) return [...result, layer];

    return result;
  }, []);
};
